import { useState, useEffect} from "react";
import {CommonDialogBox} from "components";
import { Box, Stack, DialogProps } from "@mui/material";
import Select from '@material-ui/core/Select';
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { voxbmrotation } from "constants/common";
import { useDispatch, useSelector} from 'react-redux';
import { closeProcessDialog} from 'store/main/viewObjects';
import { RootState } from 'store';
import { styled } from "@mui/material/styles";
import LinearProgress from '@mui/material/LinearProgress';
import AlertNotification from "components/AlertNotification";

function CreateProcessPanel(props:any) {
    
    const {name} = props;
    const dispatch = useDispatch();
    const viewObject = useSelector((state: RootState) => state.main.viewObject);
    const { objSources, objType, processState:open } = viewObject;
    const [itemName, setItemName] = useState('New ' + name)
    const [itemNameError, setItemNameError] = useState(false)
    const [helperItemName, setHelperItemName] = useState('')
  
    
	const [message, setMessage] = useState('')
	const [alertType, setAlertType] = useState('')
	const [loading, setLoading] = useState(false)
	const [progress, setProgress] = useState(false)
    const [orthovoxtranslateX, setorthovoxtranslateX] = useState(0)
    const [orthovoxtranslateY, setorthovoxtranslateY] = useState(0)
    const [orthovoxtranslateZ, setorthovoxtranslateZ] = useState(0)

    const [orthovoxscaleX, setorthovoxscaleX] = useState(1)
    const [orthovoxscaleY, setorthovoxscaleY] = useState(1)
    const [orthovoxscaleZ, setorthovoxscaleZ] = useState(1)

    const [orthovoxRotateX, setOrthovoxRotateX] = useState(0)
    const [orthovoxRotateY, setOrthovoxRotateY] = useState(0)
    const [orthovoxRotateZ, setOrthovoxRotateZ] = useState(0)
    const [source, setSource] = useState([])
    const [orthovoxRotateOrder, setOrthovoxRotateOrder] = useState('ZXZ')
   
    const closeComposeDialog: DialogProps["onClose"] = (event, reason) => {
        dispatch(closeProcessDialog({}))
    }

	const cancel = () => {
        dispatch(closeProcessDialog({}))
	}
 
    const handleName = (e:any) => {
        setItemName(e.target.value)
        if(e.target.value === ''){
            setItemNameError(true);
            setHelperItemName("Please select a name");
        }else{
            setItemNameError(false);
            setHelperItemName("");
        }
    }

    const CustomTextField = styled(TextField)({
        "& .MuiInputBase-root": {
          height: "40px", // Set your desired height
        },
    });

    const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
        "&.Mui-selected": {
          backgroundColor: "#3DABE6",
          color: "white",
        },
        "&.Mui-selected:hover": {
          backgroundColor: "#1275aa",
        },
      }));

    
    const DialogAction = () => {
        return (
            <>
                <Button onClick={cancel}>Cancel</Button>
                <Button 
                    variant="contained"
                    color="primary"
                    type="submit" onClick={() => console.log("Click")}
                >
                    Create
                </Button>
            </>
        )
    }

      
    return (
		<>
            <CommonDialogBox
                classes={{
                    paper: 'm-24 rounded-8 white-bg'
                }}
                open={open}
                handleClose={closeComposeDialog}
                fullWidth
                maxWidth="sm"
                subtitle1={`New ${name}`}
                titleh5=''
                dialogAction={<DialogAction />}
                displayScrollBar={true}
                maxHeight={600}
            >
                <div id="progressContainer" style={{ display:'none' }}></div>
                {
                loading && (
                    <>
                    <AlertNotification variant={"standard"} type={alertType} message={message} />
                    {
                    progress && (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                        )
                    }
                    </>
                    )
                }
                <Stack 
                    gap={1}
                >
                    <CustomTextField
                        required
                        margin="dense"
                        id="itemName"
                        name="itemName"
                        label="Item Name"
                        error={itemNameError}
                        helperText={helperItemName}
                        value={itemName}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e) => handleName(e)}
                    /> 
                   
                    <Select
                        required
                        margin="dense"
                        id="orthovox-select-mesh"
                        name="orthovox-select-mesh"
                        label="Source Mesh"
                        value={source}
                        multiple
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e:any) => setSource(e.target.value)}
                    >
                        {
                            objSources.filter((item:any) => item.type === objType).map((elem:any, index:any) => <CustomMenuItem value={elem.id} key={index}>{elem.name}</CustomMenuItem>)

                        }
                    </Select> 
                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-translate-x"
                        name="orthovox-translate-x"
                        label="Translate X"
                        value={orthovoxtranslateX}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxtranslateX(parseInt(e.target.value))}
                    /> 
                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-translate-y"
                        name="orthovox-translate-y"
                        label="Translate Y"
                        value={orthovoxtranslateY}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxtranslateY(parseInt(e.target.value))}
                    />
                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-translate-z"
                        name="orthovox-translate-z"
                        label="Translate Z"
                        value={orthovoxtranslateZ}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxtranslateZ(parseInt(e.target.value))}
                    />
                             
                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-scale-x"
                        name="orthovox-scale-x"
                        label="Scale X"
                        type="txt"
                        fullWidth
                        value={orthovoxscaleX}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxscaleX(parseInt(e.target.value))}
                    /> 
                       
                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-scale-x"
                        name="orthovox-scale-x"
                        label="Scale X"
                        type="txt"
                        fullWidth
                        value={orthovoxscaleX}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxscaleX(parseInt(e.target.value))}
                    /> 
                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-scale-y"
                        name="orthovox-scale-y"
                        label="Scale Y"
                        type="txt"
                        fullWidth
                        value={orthovoxscaleY}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxscaleY(parseInt(e.target.value))}
                    /> 
                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-scale-z"
                        name="orthovox-scale-z"
                        label="Scale Z"
                        type="txt"
                        fullWidth
                        value={orthovoxscaleZ}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxscaleZ(parseInt(e.target.value))}
                    /> 

                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-rotate-x"
                        name="orthovox-rotate-x"
                        label="Rotate X"
                        type="txt"
                        fullWidth
                        value={orthovoxRotateX}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateX(parseInt(e.target.value))}
                    /> 
                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-rotate-y"
                        name="orthovox-rotate-y"
                        label="Rotate Y"
                        type="txt"
                        fullWidth
                        value={orthovoxRotateY}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateY(parseInt(e.target.value))}
                    /> 
                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-rotate-z"
                        name="orthovox-rotate-z"
                        label="Rotate Z"
                        type="txt"
                        fullWidth
                        value={orthovoxRotateZ}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateZ(parseInt(e.target.value))}
                    /> 
      
                    <CustomTextField
                        required
                        margin="dense"
                        id="orthovox-select-rotation-order"
                        name="orthovox-select-rotation-order"
                        label="Rotate Order"
                        type="txt"
                        select
                        fullWidth
                        value={orthovoxRotateOrder}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateOrder(e.target.value)}
                    >
                        {
                            voxbmrotation.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                        }
                    </CustomTextField> 
                   
                </Stack>
            </CommonDialogBox>
		</>
  	)
}

export default CreateProcessPanel